/**
 * 案件専用
 * ヘッダーの掲載求人数等をメインビジュアル下に設置
 *
 */
export default (APP) => {
  if (!document.querySelector('#info-recruit') || !document.querySelector('#info-recruit-add')) return

  const target = document.getElementById('info-recruit') // コピー対象
  const addTarget = document.getElementById('info-recruit-add')// コピー追加先

  const cloneTarget = target.cloneNode(true)
  cloneTarget.removeAttribute('id')
  cloneTarget.removeAttribute('data-drawer')

  addTarget.appendChild(cloneTarget)
}
